import React from 'react';

const NotFoundRoute: React.FC = () => (
  <div>
    <h3>Whoops! Not found!</h3>
  </div>
);

export default NotFoundRoute;
